import clsx from 'clsx'
import { MISSION_CALCULATING_STATUSES, PATH } from 'utils/constants'

import style from './ScenariosList.module.css'

interface IScenario {
  id: number
  name: string
  missions_ids: number[]
  missions_statuses: string[]
  status?: string
  missions_type_inconsistent?: boolean
}

const ScenarioModalItem = ({
  scenario,
  selected,
  onSelect,
}: {
  scenario: IScenario
  selected: boolean
  onSelect: () => void
}) => {
  return (
    <div className={selected ? clsx(style.tableItem, style.selected) : style.tableItem} onClick={onSelect}>
      <span>{scenario.id}</span>
      <span>{scenario.name}</span>
      <span className={style.missions}>{scenario.missions_ids?.join(', ')}</span>
      <a className={style.link} href={`${PATH.SCENARIOS}${scenario.id}`} target="_blank" rel="noreferrer">
        Show
      </a>
    </div>
  )
}

const ScenariosList = ({
  scenarios,
  selectedScenario,
  onSelect,
  onScrollBottom,
  allowEmptyScenarios = false,
  hideInconsistentScenarios = false,
}: {
  scenarios: IScenario[]
  selectedScenario: IScenario | undefined
  onSelect: (scenario: IScenario) => void
  onScrollBottom?: () => void
  allowEmptyScenarios?: boolean
  /** When true, do not show scenarios with different mission types (for task assignment) */
  hideInconsistentScenarios?: boolean
}) => {
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      onScrollBottom?.()
    }
  }

  // Only show scenarios where all missions have status OK (or scenarios that have no missions yet, if allowed)
  // When hideInconsistentScenarios, exclude scenarios with mixed mission types (e.g. for task assignment)
  const filteredScenarios = scenarios.filter(scenario => {
    if (hideInconsistentScenarios && scenario.missions_type_inconsistent) return false
    const isEmpty = !scenario.missions_statuses || scenario.missions_statuses.length === 0
    if (isEmpty) return allowEmptyScenarios
    return scenario.missions_statuses.every(s => s === MISSION_CALCULATING_STATUSES.OK)
  })
  return (
    <>
      <div className={style.table} onScroll={handleScroll}>
        <div className={style.tableHeader}>
          <span>ID</span>
          <span>Name</span>
          <span>Missions</span>
          <span>Link</span>
        </div>
        {filteredScenarios.map(scenario => (
          <ScenarioModalItem
            key={scenario.id}
            scenario={scenario}
            selected={scenario?.id === selectedScenario?.id}
            onSelect={() => onSelect(scenario)}
          />
        ))}
      </div>
    </>
  )
}

export default ScenariosList
